import React from "react";
import { StaticCanvas, TStaticDrawFunction } from "../../../Components/Canvas";
import { Paper, Stack, Typography } from "@mui/material";

export interface IChartProps {
  title: string;
  draw: TStaticDrawFunction;
  width: number;
  height: number;
}

const MeasurementChart = (props: IChartProps) => {
  const { title, width, height, draw } = props;

  return (
    <Paper>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={0}
        padding={0.25}
      >
        <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
          {title}
        </Typography>
        <StaticCanvas draw={draw} width={width} height={height} />
      </Stack>
    </Paper>
  );
};

export default MeasurementChart;
